import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import icons from './icons';

const Wrapper = styled.span`
  display: inline-block;
`;

class Icon extends PureComponent {
  sizeToPx(size) {
    const sizeMapping = {
      xs: 8,
      s: 12,
      m: 20,
      l: 24,
      xl: 40,
      xxl: 110,
    };
    return size in sizeMapping ? sizeMapping[size] : 16;
  }

  render() {
    const size = this.sizeToPx(this.props.size);
    const { name, color: colorProp } = this.props;
    let color = this.props.color
      ? this.props.color
      : this.props.theme.color.primary;
    if (colorProp === 'secondary') {
      color = this.props.theme.color.font.secondary;
    }
    return (
      <Wrapper className={this.props.className}>
        {icons[name](size, color)}
      </Wrapper>
    );
  }
}

Icon.propTypes = {
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
  color: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    color: PropTypes.shape({}).isRequired,
  }).isRequired,
};

Icon.defaultProps = {
  size: 'm',
  color: null,
  className: '',
};

export default withTheme(Icon);
export { default as icons } from './icons';



// WEBPACK FOOTER //
// ./src/components/Icon/index.js